import moment from "moment-timezone";
import { ISelect } from "../Interfaces/base";
import { UsStatesType } from "../constants/usState";

export const getTimezoneOptions = (): ISelect[] => moment.tz.zonesForCountry('US').map(zone => ({
  label: `${zone} (${moment.tz(zone).zoneAbbr()})`,
  value: zone,
}));

// the Select control expects a list of {value, label} objects as options
// most of the time api response is different than what the Select control expects
// so here we do the transformation
export const toSelectOptions = (list: UsStatesType[], valueProp = 'id', labelProp = 'name') => {
  return list.map((item: { [x: string]: any; }) => ({
    label: item[labelProp],
    value: item[valueProp],
  }));
}